export const sideMenuReducer = (state = {selectedItem: 0}, action) => {
    switch(action.type){
        case 'SET_SIDE_MENU_SELECTED_ITEM': return {...state, selectedItem: action.payload.selectedItem}
        default: return state
    }
}
